module.exports = __webpack_public_path__ + "img/pagination-energySavingsActivated.3f12a8ba.svg";